import React from "react";

const ThemeToggle = () => {
  const [theme, setTheme] = React.useState(
    () => document.documentElement.dataset.theme || "light"
  );

  const toggle = () => {
    const next = theme === "dark" ? "light" : "dark";
    document.documentElement.dataset.theme = next;
    try {
      localStorage.setItem("theme", next);
    } catch (e) {
      // private browsing — theme just won't persist
    }
    setTheme(next);
  };

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggle}
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
    >
      {theme === "dark" ? "Light" : "Dark"} ◐
    </button>
  );
};

export default ThemeToggle;
